import { Button, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { canExecuteTask, Task, TaskCompletion, TaskStatus } from "../../../../interface/Task";
import TaskDescription from "../Tasks/TaskDescription";
import { displayTime, TimeInterface } from "../../../../interface/Time";
import { CustomEvent } from "../../../../interface/CustomEvent";
import { toast } from "react-toastify";
import React from "react";
import { GameContext } from "../../../../contexts/GameContext";
import { StyledPopper } from "../../../ArrowStyles";


interface Props {
    scrollRef: React.MutableRefObject<HTMLDivElement | null>,
    time: TimeInterface,
    points: number,
    triggerAction: (eventId?: number, taskId?: number) => void,
    canTrigger: boolean,
    tasksInProgress: TaskCompletion[]
}


const Events = ({ scrollRef, time, canTrigger, points, triggerAction, tasksInProgress }: Props) => {
    const { events, round } = useContext(GameContext);

    function getAllTasks() {
        const res: Task[][] = [];
        if (round < events.length) {
            events[round].forEach((e: CustomEvent) => {
                const eventTasks: Task[] = [];
                e.tasks.forEach((task: Task) => {
                    eventTasks.push(task);
                });
                res.push(eventTasks);
            });
        }

        return res;
    }

    const [tasks, setTasks] = useState<Task[][]>(getAllTasks());
    const [selectedTask, setSelectedTask] = useState<Task>();

    // const [showPopper, setShowPopper] = useState<boolean>();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);


    useEffect(() => {
        setTasks(getAllTasks());
    }, [events])


    const handleShowPopper = (isHover: boolean, task: Task) => (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(!isHover ? null : event.currentTarget);
        setSelectedTask(task)
    };

    function executeTask(eventId: number, taskId: number) {
        const clonedTask = { ...tasks[eventId][taskId] };
        let taskCompletion = null;
        const tasksToCheck = tasksInProgress.filter(element => element.eventId === eventId && element.taskId === taskId)
        if (tasksToCheck.length > 0) { taskCompletion = tasksToCheck[0]; }
        const taskRes = canExecuteTask(clonedTask, time, points, taskCompletion, events[round][eventId]);
        if (typeof taskRes === "string") {
            toast(taskRes);
            return;
        }

        if (taskRes && canTrigger) {
            const clonedState = [...tasks];
            clonedState[eventId][taskId] = clonedTask;
            setTasks(clonedState);

            triggerAction(eventId, taskId);
        }
    }

    const open = Boolean(anchorEl);

    return (
        <Stack ref={scrollRef} className="event-name" >

            {events[round].length > 0 && events[round].map((event, eventId) =>
                event.triggerTime ? <></> :
                    <Stack key={eventId} gap={2}>
                        <Typography variant="h5">{event.name}</Typography>
                        {/*
                        <Typography variant="body2" sx={{ "opacity": 0.8 }}>{event.description}</Typography>
                        <Stack gap={1}>

                            {eventId < tasks.length && tasks[eventId].map((task, taskId) =>
                                <Button
                                    key={taskId}
                                    variant={task.status === TaskStatus.IN_PROGESS ? "outlined" : "contained"}
                                    disabled={task.status === TaskStatus.DONE}
                                    sx={{ backgroundColor: task.status === TaskStatus.IN_PROGESS ? "none" : '#4074c8', display: "flex", flexDirection: "column", textTransform: "none" }}
                                    onClick={() => executeTask(eventId, taskId)}
                                    onMouseEnter={handleShowPopper(true, task)}
                                    onMouseLeave={handleShowPopper(false, task)}
                                >
                                    <div style={{ "fontWeight": "bold", "padding": "0", "lineHeight": 1.5 }}>
                                        {task.name}
                                    </div>
                                    {event.triggerTime ? <></> :
                                        <div style={{ "fontSize": ".8em", "lineHeight": 1.25 }}>
                                            ({displayTime(task.timeConstraint.after)}-{displayTime(task.timeConstraint.before)})
                                        </div>}
                                </Button>
                            )}
                            {selectedTask &&
                                <StyledPopper sx={{ zIndex: 5, mr: 30 }} id={selectedTask.name.toString()} open={open} anchorEl={anchorEl} placement="left">
                                    <TaskDescription task={selectedTask} />
                                </StyledPopper>}
                        </Stack>
                        */}
                    </Stack>

            )}
        </Stack >
    );
};

export default Events;